/* eslint-disable @typescript-eslint/no-explicit-any */
import { combineReducers } from "@reduxjs/toolkit";

import login from "./login";
import user, { UserState } from "./user";
import userCreate, { UserCreateState } from "./user/create";
import userEdit, { UserEditState } from "./user/edit";
import userDetail, { UserDetailState } from "./user/detail";

import bankBillet, { BankBilletState } from "./bankBillet";
import bankBilletCreate, { BankBilletCreateState } from "./bankBillet/create";
import bankBilletEdit, { BankBilletEditState } from "./bankBillet/edit";
import bankBilletDetail, { BankBilletDetailState } from "./bankBillet/detail";

import company, { CompanyState } from "./company";
import companyCreate, { CompanyCreateState } from "./company/create";
import companyEdit, { CompanyEditState } from "./company/edit";
import companyDetail, { CompanyDetailState } from "./company/detail";

import mei, { MeiState } from "./mei";
import meiCreate, { MeiCreateState } from "./mei/create";
import meiEdit, { MeiEditState } from "./mei/edit";
import meiDetail, { MeiDetailState } from "./mei/detail";

import subscription, { SubscriptionState } from "./subscription";
import subscriptionCreate, {
	SubscriptionCreateState
} from "./subscription/create";
import subscriptionEdit, { SubscriptionEditState } from "./subscription/edit";
import subscriptionDetail, {
	SubscriptionDetailState
} from "./subscription/detail";

import configuration, { ConfigurationState } from "./configuration";
import plan, { PlanState } from "./plan";
import paymentMethod, { PaymentMethodState } from "./paymentMethod";
import marketing, { MarketingState } from "./marketing";

import charge, { ChargeState } from "./charge";

import das, { DasState } from "./das";

import emails, { EmailsState } from "./emails";

import invoice, { InvoiceState } from "./invoice";

import nfse, { NFSeState } from "./nfse";
import nfseCreate, { NFSeCreateState } from "./nfse/create";
import nfseEdit, { NFSeEditState } from "./nfse/edit";
import nfseDetail, { NFSeDetailState } from "./nfse/detail";

import transfer, { TransferState } from "./transfer";
import transferCreate, { TransferCreateState } from "./transfer/create";
import transferEdit, { TransferEditState } from "./transfer/edit";
import transferDetail, { TransferDetailState } from "./transfer/detail";
import dasn, { DasnState } from "./dasn";
import dashboard, { HomeDashboardState } from "./home";

export interface State {
	bankBillet: BankBilletState;
	bankBilletCreate: BankBilletCreateState;
	bankBilletDetail: BankBilletDetailState;
	bankBilletEdit: BankBilletEditState;
	charge: ChargeState;
	company: CompanyState;
	companyCreate: CompanyCreateState;
	companyDetail: CompanyDetailState;
	companyEdit: CompanyEditState;
	configuration: ConfigurationState;
	dashboard: HomeDashboardState;
	das: DasState;
	dasn: DasnState;
	emails: EmailsState;
	invoice: InvoiceState;
	login: any;
	marketing: MarketingState;
	mei: MeiState;
	meiCreate: MeiCreateState;
	meiDetail: MeiDetailState;
	meiEdit: MeiEditState;
	nfse: NFSeState;
	nfseCreate: NFSeCreateState;
	nfseDetail: NFSeDetailState;
	nfseEdit: NFSeEditState;
	paymentMethod: PaymentMethodState;
	plan: PlanState;
	subscription: SubscriptionState;
	subscriptionCreate: SubscriptionCreateState;
	subscriptionDetail: SubscriptionDetailState;
	subscriptionEdit: SubscriptionEditState;
	transfer: TransferState;
	transferCreate: TransferCreateState;
	transferDetail: TransferDetailState;
	transferEdit: TransferEditState;
	user: UserState;
	userCreate: UserCreateState;
	userDetail: UserDetailState;
	userEdit: UserEditState;
}

const reducers = {
	bankBillet,
	bankBilletCreate,
	bankBilletDetail,
	bankBilletEdit,
	charge,
	company,
	companyCreate,
	companyDetail,
	companyEdit,
	configuration,
	das,
	dasn,
	emails,
	invoice,
	login,
	marketing,
	mei,
	meiCreate,
	meiDetail,
	meiEdit,
	nfse,
	nfseCreate,
	nfseDetail,
	nfseEdit,
	paymentMethod,
	plan,
	subscription,
	subscriptionCreate,
	subscriptionDetail,
	subscriptionEdit,
	transfer,
	transferCreate,
	transferDetail,
	transferEdit,
	user,
	userCreate,
	userDetail,
	userEdit,
	dashboard
};

const rootReducer = combineReducers(reducers);

export default rootReducer;
